import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/* https://ng-bootstrap.github.io/#/components/alert/examples */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/* https://www.npmjs.com/package/ng5-slider */
import { Ng5SliderModule } from 'ng5-slider';

/* https://www.npmjs.com/package/@agm/core */
import { AgmCoreModule } from '@agm/core';

/* https://www.npmjs.com/package/ng2-rut */
import { Ng2Rut, RutValidator } from 'ng2-rut';

/* https://www.npmjs.com/package/ngx-ui-loader */
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "#c3c6c6",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 15,
  "fgsColor": "#c3c6c6",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.95)",
  "pbColor": "#FF6600",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "threshold": 500,
  "text": "Cargando"
};

/* App */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* Core */
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { AuthGuard } from './core/guard/auth.guard';

/* Features */
import { BookingComponent } from './features/booking/booking.component';
import { SearchTypeSelectionComponent } from './features/booking/pages/search-type-selection/search-type-selection.component';
import { SelectDatetimeComponent } from './features/booking/pages/select-datetime/select-datetime.component';
import { PreBookingComponent } from './features/booking/pages/pre-booking/pre-booking.component';
import { PersonalInformationComponent } from './features/booking/pages/personal-information/personal-information.component';
import { NextHourPipe } from './shared/pipes/nextHour.pipe';
import { SelectPlantComponent } from './features/booking/pages/select-plant/select-plant.component';
import { BookingConfirmedComponent } from './features/booking/pages/booking-confirmed/booking-confirmed.component';
import { PaymentComponent } from './features/booking/pages/payment/payment.component';
import { ChangeBookingComponent } from './features/booking/pages/change-booking/change-booking.component';
import { DatetimeChangeBookingComponent } from './features/booking/pages/datetime-change-booking/datetime-change-booking.component';
import { EndingBookingComponent } from './features/booking/pages/ending-booking/ending-booking.component';

/* Directives */
import { OnlyNumberDirective } from './shared/directives/only-number.directive';
import { PatentFormatDirective } from './shared/directives/patent-format.directive';

/* Other components */
import { CustomDatepickerI18n } from './features/customdatepicker/datepicker-i18n';
import { ErrorsComponent } from './features/errors-component/errors.component';
import { ToastrModule } from 'ngx-toastr';
import { DatepickerComponent } from './features/booking/pages/search-type-selection/datepicker/datepicker.component';

/* Recaptcha */
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';
import { environment } from 'src/environments/environment.prod';

@NgModule({
  declarations: [
    AppComponent,
    ErrorsComponent,
    BookingComponent,
    SearchTypeSelectionComponent,
    SelectDatetimeComponent,
    PreBookingComponent,
    PersonalInformationComponent,
    NextHourPipe,
    SelectPlantComponent,
    DatepickerComponent,
    BookingConfirmedComponent,
    PaymentComponent,
    ChangeBookingComponent,
    DatetimeChangeBookingComponent,
    EndingBookingComponent,
    OnlyNumberDirective,
    PatentFormatDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    Ng5SliderModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(), // ToastrModule added
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBj0RQ9I7F5hfLEeDg4SyGqBMXMil_MAyg'
    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    Ng2Rut,
    RecaptchaV3Module
  ],
  providers: [
    AuthGuard,
    RutValidator,
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDatepickerI18n
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey // '6Lc5mjQjAAAAAMzqtnh30LwR4qLz49ysZw4uDIhI'
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DatepickerComponent
  ]
})
export class AppModule { }
